import angular from 'angular';
import ComponentsModule from '../components-module';
import template from './code-content-card.html';
import Debug from 'ace-ui/ace-debug';

const COMPONENT_NAME = 'codeContentCard';
const debug = new Debug(COMPONENT_NAME);

angular.module (ComponentsModule)
  .component (COMPONENT_NAME, {
    template,
    bindings: {
      displayAs: '@?',
      contentCard: '<',
      contentCopy: '<?'
    },
    controllerAs: 'card',
    controller: ($scope) => {
      let card = $scope.card;
      let thumbnailUrl;

      card.$onInit = () => {
        debug.log ('$onInit', card);
        card.displayAs = card.displayAs || 'card';
        thumbnailUrl = card.contentCard && card.contentCard.thumbnail && card.contentCard.thumbnail.url;
      };

      card.$doCheck = () => {
        if (card.contentCard && card.contentCard.thumbnail && card.contentCard.thumbnail.url !== thumbnailUrl) {
          card.thumbnail = card.contentCard.thumbnail;
          thumbnailUrl = card.thumbnail.url;
        }
      };

      card.$onChanges = ({ contentCard }) => {
        if (contentCard && contentCard.currentValue) {
          card.alias = contentCard.currentValue.alias;
          card.color = contentCard.currentValue.color;
          card.contentType = contentCard.currentValue.contentType;
          card.thumbnail = Object.assign ({}, contentCard.currentValue.thumbnail);
          card.label = Object.assign ({}, contentCard.currentValue.label);
          card.abstract = Object.assign ({}, contentCard.currentValue.abstract);
          card.datetime = Object.assign ({}, contentCard.currentValue.datetime);
          card.classifiers = Object.assign ([], contentCard.currentValue.classifiers);
          card.hasClassifiers = card.classifiers.length > 0;
          card.tags = Object.assign ({}, contentCard.currentValue.tags);
        }
      };
    }
  });